import {ToggleButton, ToggleButtonGroup, Tooltip} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Calendar03Icon, GridViewIcon, ListViewIcon} from "@hugeicons/core-free-icons";

export const CollectionViewToggle = ({value, onChange, withCalendar = false, withList = true}) => (
    <ToggleButtonGroup
        value={value} exclusive size="small" aria-label="Collection view"
        onChange={(event, next) => next && onChange(next)}
        sx={{gap: 0.5, flexShrink: 0, "& .MuiToggleButton-root": {
            border: "none", borderRadius: 2, px: 1.5, py: 0.75,
            color: "text.secondary",
            "&:hover": {bgcolor: "grey.300"},
            "&.Mui-selected": {bgcolor: "grey.200", color: "grey.700"},
        }}}
    >
        {withList && (
            <ToggleButton value="list" aria-label="List view">
                <Tooltip title="List view"><HugeiconsIcon icon={ListViewIcon} size={18}/></Tooltip>
            </ToggleButton>
        )}
        <ToggleButton value="cards" aria-label="Card view">
            <Tooltip title="Card view"><HugeiconsIcon icon={GridViewIcon} size={18}/></Tooltip>
        </ToggleButton>
        {withCalendar && (
            <ToggleButton value="calendar" aria-label="Calendar view">
                <Tooltip title="Calendar view"><HugeiconsIcon icon={Calendar03Icon} size={18}/></Tooltip>
            </ToggleButton>
        )}
    </ToggleButtonGroup>
);
